// Angular imports
import { Input } from '@angular/core';

// 3rd party imports
import { DxChartComponent } from 'devextreme-angular';

// Service imports
import { ScreenService } from '../_services/shared-services/screen.service';
import { ContextManagerService } from '../_services/data-services/context-manager.service';
import { HelperService } from '../_services/shared-services/helper.service';
import { UserService } from '../_services/data-services/user.service';

export abstract class MPBaseChartComponent {
    @Input() width = NaN;
    @Input() height = NaN;
    @Input() widgetMode = false;

    isSmallScreen = false;
    chart: DxChartComponent;
    isInternalUser: boolean;

    constructor(
        protected readonly screenService: ScreenService,
        protected readonly contextManagerService: ContextManagerService,
        protected readonly helperService: HelperService,
        protected readonly userService: UserService
    ) {
        this.isSmallScreen = this.screenService.isSmallScreen();
        this.screenService.changed.subscribe(() => this.updateScreenSize());
        this.screenService.resized.subscribe(() => this.updateScreenSize());
        this.helperService.subjectSideNavSizeChanged.subscribe(() => this.updateScreenSize());
        this.isInternalUser = this.userService.isInternal();
    }

    getPointName(pointInfo: any, breakpoint = 10): string {
        let pointName = '';
        if (pointInfo.pointName.length > breakpoint) {
            const nameList = pointInfo.pointName.split(' ');
            nameList.forEach((name) => {
                if (!!pointName) {
                    if (name.length > breakpoint / 2) {
                        pointName += '\n';
                        pointName += name;
                    } else {
                        pointName += name;
                    }
                } else {
                    pointName = name;
                }
                pointName += ' ';
            });
        } else {
            pointName = pointInfo.pointName;
        }
        return pointName;
    }

    horizontalAlignment = (): string => {
        if (this.isSmallScreen) {
            return 'center';
        } else {
            return 'right';
        }
    };

    getExportFileName(title: string): string {
        const selectedContext = this.contextManagerService.getSelectedContext();
        if (!!selectedContext) {
            let fileName = `${selectedContext.communityName} ${title}`;
            fileName = fileName.replace('-', '').split(' ').join('_').replace('__', '_');
            return fileName;
        }
        return null;
    }

    setChartSize(): void {
        if (!this.widgetMode) {
            let fixedHeight = this.isSmallScreen ? 350 : 250;
            let fixedWidth = this.isSmallScreen ? 550 : 450;
            if (!this.isSmallScreen) {
                const formContainer: Element = document.getElementById('form-container');
                if (formContainer) {
                    fixedHeight = (formContainer.clientHeight - 20) / 2;
                    fixedWidth = (formContainer.clientWidth - 20) / 2;
                }
                this.width = fixedWidth;
                this.height = fixedHeight;
            } else {
                const firstItem: Element = document.getElementsByClassName('chart-container')[0];
                if (!!firstItem) {
                    this.width = this.isSmallScreen
                        ? Math.min(firstItem['clientWidth'] - 10, fixedWidth)
                        : Math.max(firstItem['clientWidth'] - 10, fixedWidth);
                    this.height = Math.max(firstItem['clientHeight'] - 10, fixedHeight);
                }
            }
        }
    }

    private updateScreenSize(): void {
        this.isSmallScreen = this.screenService.isSmallScreen();
        const isMedium = this.screenService.isMediumScreen();
        if (isMedium && window.screen.width <= 1024) {
            this.isSmallScreen = true;
        }
        setTimeout(() => {
            this.setChartSize();
        }, 500);
    }
}
